import React from "react";
import { useDarkMode } from "../../../Services/Context/DarkModeContext";
import { useLanguage } from "../../../Services/Context/LanguageContext";
import "./DarkModeToggle.css";

const DarkModeToggle = () => {
  const { dark, setDark } = useDarkMode();
  const { translate } = useLanguage();

  return (
    <button className="Darkmode-toggle" onClick={() => setDark(!dark)}>
      {dark ? translate("lightMode") : translate("darkMode")}
    </button>
  );
};

export default DarkModeToggle;
